import React, { Component } from 'react';

import AppContent from '../shared/AppContent';
import {AuthContext} from "../../authContext";
import Button from "../shared/Button";
import CategoryDisplay from './CategoryDisplay';
import { citycadMajorVersion } from "../../configuration";
import Loading from "../shared/Loading";
import PageHeading from '../shared/PageHeading';
import {getAllHelpContent, getHelpSearchResults} from "../data/data";
import Flex from "../shared/Flex";
import TextInput from "../shared/form/TextInput";
import processHelpData from "./processHelpData";

class Help extends Component {
  state = {
    categories: [],
    hasDoneSearch: false,
    isLoading: true,
    isSearching: false,
    previousSearchTerms: "",
    searchResults: [],
    searchTermConsistencyTimer: 0,
    searchTerms: ""
  };
  static contextType = AuthContext;
  componentDidMount = async () => {
    const helpArticles = await getAllHelpContent(citycadMajorVersion);
    const helpData = await processHelpData(helpArticles);
    const categories = helpData.categories;

    await this.setState({
      isLoading: false,
      categories: categories
    });
  };
  handleSearchInputChange = async e => {
    await this.setState({searchTerms: e.target.value});
  };
  search = async searchTerms => {
    await this.setState({isSearching: true, results: {}});
    const results = await getHelpSearchResults(searchTerms, citycadMajorVersion);
    await this.setState({
      searchResults: results.data,
      hasDoneSearch: true,
      isSearching: false,
      searchTermConsistencyTimer: 0
    });
  };
  render() {
    if (this.state.isLoading)
      return (
        <Loading />
      );
    return (
      <AppContent>
        <PageHeading>CityCAD Help</PageHeading>
        {
          this.context.isCityCAD === true
          &&
          <Flex centre>
            <Flex>
              <TextInput
                style={{padding: "10px", maxWidth: "500px"}}
                value={this.state.searchTerms}
                placeholder={`Search CityCAD Help...`}
                name="searchTerms"
                type="text"
                autoComplete={"off"}
                onChange={this.handleSearchInputChange}
              />
              <Button style={{margin: "10px"}} onClick={() => this.search(this.state.searchTerms)}>
                Go
              </Button>
            </Flex>
          </Flex>
        }
        {
          this.state.isSearching
          &&
          <Loading />
        }
        {
          this.state.hasDoneSearch && this.state.searchResults.length === 0
          &&
          <p>No search results</p>
        }
        {
          this.state.searchResults.length > 0
          &&
          <CategoryDisplay title="Search Results" articles={this.state.searchResults}/>
        }
        <div>
          {this.state.categories.map(category => {
            if (category.id !== "1") {
              return (
                <CategoryDisplay categoryId={category.id} gettingStarted={false} key={Math.random()} title={category.name} articles={category.articles} />
              );
            }
            else
              return ''
          })}
        </div>

      </AppContent>
    );
  }
}

export default Help;
